<template>
  <div>
    <page-header
      has-return
      :page="pageHeaderConfig"
      :actions="pageActionConfig"
    />
    <filter-manager
      v-if="!showCharger"
      ref="filterRef"
      :filters="filtersConfig"
      :display-advanced="false"
      search-icon="fa fa-sync pr-2"
      search-text=""
      search-container-class="d-flex align-items-center justify-content-end"
      v-model="filterModel"
      @search="onProcessHandler"
    >
      <div class="col d-flex justify-content-end align-items-center">
        <dropdown
          icon="fas fa-print"
          :items="reportOptions"
          title="Seleccione"
        />
      </div>
    </filter-manager>
    <custom-month-charger-component
      v-if="showCharger"
      :year-list="filterOptions.academicYears"
      @cancel-event="cancelEvent"
      @continue-event="executeLoadReport"
    />
  </div>
</template>

<script>
//libs components
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import Dropdown from 'dropdown'

//services
import AcademicYearServices from '@/services/api/academicyear.api'
import ReportServices from '@/modules/report/api'
import ReportMonthServices from '@/services/api/report.api'
import DocumentServices from '@//modules/report/document'
import CustomMonthChargerComponent from '@/components/common/reports/CustomMonthChargerComponent.vue'
import { getValidationMessages } from '@/modules/common/api'
//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'

//constants
import codeAcademicYear from '@/utils/constants/codeAcademicYear.js'

export default {
  name: 'Report2B',
  components: {
    PageHeader,
    FilterManager,
    Dropdown,
    CustomMonthChargerComponent,
  },
  mixins: [alertMixin],
  data: () => ({
    filterOptions: {
      academicYears: [],
      months: [],
    },
    filterModel: {
      academicYear: null,
      month: null,
    },
    showCharger: false,
    validationMessages: [],
  }),
  computed: {
    pageHeaderConfig() {
      return {
        icon: 'fas fa-chart-pie',
        title: 'Informe 2B',
        routes: ['Inicio', 'Reportes', 'Informe 2B'],
      }
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-4',
          options: this.filterOptions.academicYears,
          value: this.filterModel.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          class: 'col-12 col-md-4',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Mes',
          error: 'El mes es requerido.',
          validations: 'required',
          options: this.filterOptions.months,
          value: this.filterModel.month,
        },
      ]
    },
    reportOptions() {
      return [
        {
          label: 'Excel',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(false),
        },
        {
          label: 'PDF',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(true),
        },
      ]
    },
  },
  async mounted() {
    await this.getInitialFilters()
  },
  methods: {
    async getInitialFilters() {
      this.filterOptions.academicYears = (
        await AcademicYearServices.getCalendarYearsFromSpecificYear(
          codeAcademicYear['2016-2017']
        )
      ).data
         await getValidationMessages(['0343']).then(
        (resp) => (this.validationMessages = resp)
      )
    },
     getMessage(code) {
      return this.validationMessages.find((m) => m.id === code).name
    },
    async onChangeAcademicYear() {
      this.filterModel.month = null
      this.filterOptions.months = []

      await this.getMonthsInAcademicYear()
    },
    async onProcessHandler(isPdfFormat) {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      await ReportServices.getReport('b2report', {
        academicYearId: this.filterModel.academicYear.id,
        month: this.filterModel.month.id,
        isPdfFormat,
      }).then((res) => DocumentServices.Download(res.data))
    },
    processToCharger() {
      this.showCharger = true
    },
    cancelEvent() {
      this.showCharger = false
    },
    async getMonthsInAcademicYear() {
      this.filterOptions.months = (
        await ReportMonthServices.getLoadedMonthsForReport(
          this.filterModel.academicYear.id,
          this.reportName
        )
      ).data
    },
    async isMonthLoadedByYear(year, month) {
      const {
        data: isMonthLoaded,
      } = await ReportMonthServices.isMonthLoadedByYear(year, month)

      return isMonthLoaded
    },
    async executeLoadReport(filter) {
      const year = filter.year.name
      const month = filter.month.monthNumber
      if (await this.isMonthLoadedByYear(year, month)) {
        const isConfirmed = await this.ShowCancelModal(
          'Confirmación',
          this.getMessage('0343'),
          'Sí',
          'No'
        )
        if (!isConfirmed) {
          this.cancelEvent()
          return
        }
      }
      ReportMonthServices.generateReportForYearAndMonth(year, month)
        .then(() => {
          this.ShowToast('Proceso Exitoso', 'Proceso Exitoso', 'success');
          this.onChangeAcademicYear();
        })
        .catch(() => {
          this.ShowToast('Alerta', 'Ha ocurrido un error en sistema.', 'error')
        })
    },
  },
}
</script>
